/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ServiceLocationSeoFieldsAdmin
 */
export interface ServiceLocationSeoFieldsAdmin {
  /**
   *
   * @type {number}
   * @memberof ServiceLocationSeoFieldsAdmin
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof ServiceLocationSeoFieldsAdmin
   */
  locationSlug?: string | null
  /**
   *
   * @type {string}
   * @memberof ServiceLocationSeoFieldsAdmin
   */
  readonly locationName: string
  /**
   *
   * @type {string}
   * @memberof ServiceLocationSeoFieldsAdmin
   */
  header?: string | null
  /**
   *
   * @type {string}
   * @memberof ServiceLocationSeoFieldsAdmin
   */
  titleTag?: string | null
  /**
   *
   * @type {string}
   * @memberof ServiceLocationSeoFieldsAdmin
   */
  descriptionTag?: string | null
  /**
   *
   * @type {string}
   * @memberof ServiceLocationSeoFieldsAdmin
   */
  description?: string | null
  /**
   *
   * @type {boolean}
   * @memberof ServiceLocationSeoFieldsAdmin
   */
  useLocalMeta?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ServiceLocationSeoFieldsAdmin
   */
  useLocalDescription?: boolean
  /**
   *
   * @type {number}
   * @memberof ServiceLocationSeoFieldsAdmin
   */
  serviceId?: number
  /**
   *
   * @type {number}
   * @memberof ServiceLocationSeoFieldsAdmin
   */
  locationId?: number
}

/**
 * Check if a given object implements the ServiceLocationSeoFieldsAdmin interface.
 */
export function instanceOfServiceLocationSeoFieldsAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'locationName' in value

  return isInstance
}

export function ServiceLocationSeoFieldsAdminFromJSON(json: any): ServiceLocationSeoFieldsAdmin {
  return ServiceLocationSeoFieldsAdminFromJSONTyped(json, false)
}

export function ServiceLocationSeoFieldsAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ServiceLocationSeoFieldsAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    locationSlug: !exists(json, 'locationSlug') ? undefined : json['locationSlug'],
    locationName: json['locationName'],
    header: !exists(json, 'header') ? undefined : json['header'],
    titleTag: !exists(json, 'titleTag') ? undefined : json['titleTag'],
    descriptionTag: !exists(json, 'descriptionTag') ? undefined : json['descriptionTag'],
    description: !exists(json, 'description') ? undefined : json['description'],
    useLocalMeta: !exists(json, 'useLocalMeta') ? undefined : json['useLocalMeta'],
    useLocalDescription: !exists(json, 'useLocalDescription')
      ? undefined
      : json['useLocalDescription'],
    serviceId: !exists(json, 'serviceId') ? undefined : json['serviceId'],
    locationId: !exists(json, 'locationId') ? undefined : json['locationId'],
  }
}

export function ServiceLocationSeoFieldsAdminToJSON(
  value?: ServiceLocationSeoFieldsAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    locationSlug: value.locationSlug,
    header: value.header,
    titleTag: value.titleTag,
    descriptionTag: value.descriptionTag,
    description: value.description,
    useLocalMeta: value.useLocalMeta,
    useLocalDescription: value.useLocalDescription,
    serviceId: value.serviceId,
    locationId: value.locationId,
  }
}
